"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getERC20ColumnConfig = exports.getColumnConfig = void 0;
const react_1 = __importDefault(require("react"));
const getColumnConfig = () => [
    {
        title: "Banner",
        width: 1.3,
        cellRender: ({ collectionImgUrl, slug }) => react_1.default.createElement("img", { src: collectionImgUrl, height: 100, width: 200, alt: slug }),
    },
    {
        title: "Collection Name",
        width: 1.2,
        cellRender: ({ name }) => name,
    },
    {
        title: "Owned assets",
        width: 1.1,
        cellRender: ({ ownedAssetsCount }) => ownedAssetsCount,
    },
    {
        title: "Average Price",
        width: 1.2,
        cellRender: ({ avgPrice }) => avgPrice.toFixed(3),
    },
    { title: "Floor Price", width: 1, cellRender: ({ floorPrice }) => (floorPrice === 0 ? 0 : floorPrice.toFixed(3)) },
];
exports.getColumnConfig = getColumnConfig;
const getERC20ColumnConfig = () => [
    {
        title: "Network",
        width: 1.1,
        cellRender: ({ newtwork }) => newtwork,
    },
    {
        title: "Token",
        width: 1.5,
        cellRender: ({ logoUrl, name }) => (react_1.default.createElement("div", { className: "token-img", style: { display: "flex", alignItems: "center", gap: "7px" } },
            react_1.default.createElement("img", { src: logoUrl, alt: name }),
            react_1.default.createElement("span", null, name))),
    },
    {
        title: "Balance",
        width: 1.1,
        cellRender: ({ balance }) => balance,
    },
    {
        title: "Token Price",
        width: 1.5,
        cellRender: ({ tokenPriceInUsd }) => `${tokenPriceInUsd}$`,
    },
    {
        title: "Balance in USD",
        width: 1.5,
        cellRender: ({ balanceInUsd }) => `${balanceInUsd}$`,
    },
];
exports.getERC20ColumnConfig = getERC20ColumnConfig;
